import { useQuery } from '@tanstack/react-query';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { listAdminCompanies } from '@/features/company/company-api';
import { CompanyUsageConsole } from './CompanyUsageConsole';

/**
 * Usage d'une entreprise ciblée, ouvert depuis la liste des entreprises
 * (action « Voir l'usage »). Réservé au super admin via la route gardée.
 */
export function AdminCompanyUsagePage() {
  const { companyId } = useParams<{ companyId: string }>();
  const companiesQuery = useQuery({
    queryFn: () => listAdminCompanies(),
    queryKey: ['admin', 'companies', 'directory'],
  });
  const company = companiesQuery.data?.data.find((item) => item.id === companyId) ?? null;

  if (!companyId) {
    return null;
  }

  return (
    <section className="w-full space-y-6" data-testid="admin-company-usage-page">
      <div className="flex justify-end">
        <Button asChild size="sm" variant="outline">
          <Link data-testid="admin-company-usage-back" to="/admin/companies">
            <ArrowLeftIcon />
            Retour aux entreprises
          </Link>
        </Button>
      </div>
      <CompanyUsageConsole
        companyId={companyId}
        title={company ? `Usage — ${company.name}` : 'Usage de l’entreprise'}
      />
    </section>
  );
}
